module.exports = __webpack_public_path__ + "static/media/signup-new-page.c9a566a7.jpg";